import { render, staticRenderFns } from "./resourceDetail.vue?vue&type=template&id=2d9089b2&scoped=true&"
import script from "./resourceDetail.vue?vue&type=script&lang=js&"
export * from "./resourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./resourceDetail.vue?vue&type=style&index=0&id=2d9089b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9089b2",
  null
  
)

export default component.exports